import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=c6daef70&scoped=true&"
import script from "./Boxes.vue?vue&type=script&lang=js&"
export * from "./Boxes.vue?vue&type=script&lang=js&"
import style0 from "./Boxes.vue?vue&type=style&index=0&id=c6daef70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6daef70",
  null
  
)

export default component.exports